module.exports = __webpack_public_path__ + "static/img/oilApplication1.4d9da920.png";